<template>
  <div class="de-ratio">
    <div class="de-ratio-left">
        <div>
            <div :style="textStyle">
                <div>{{label}}</div>
                <div>{{percent}}%</div>
            </div>
        </div>
    </div>
    <div class="de-ratio-right" ref="chartDiv">
         <svg width="100%" height="100%" viewBox="0 0 440 440" class="center">
      <g transform="matrix(0,-1,1,0,0,440)">
            <circle cx="220" cy="220" r="170" stroke-width="30" :stroke="circleBackground" fill="none" stroke-dasharray="1069 1069"></circle>
            <circle v-if="percent" cx="220" cy="220" r="170" stroke-width="45" :stroke="circleFrontColor" stroke-linecap="round" fill="none" :stroke-dasharray="percent/100*1069+' 1069'"></circle>
        </g>
        </svg>
    </div>
  </div>
</template>
<style lang="less">
.de-ratio {
    width: 100%;
    height: 100%;
  .de-ratio-left {
    width: 50%;
    height: 100%;
    display: table;
    float: left;
    &>div{
        display:table-cell;
        vertical-align: middle;
        text-align: center;
    }
  }
  .de-ratio-right {
    width: 50%;
    height: 100%;
    display: block;
    float: left;
  }
}
</style>
<script>
export default {
    props:['percent','label', 'font', 'circleBackground', 'circleFrontColor'],
    computed:{
        textStyle(){
            return Object.assign({},this.font, {fontSize:this.font?this.font.fontSize+'px':'inherit'})
        }
    }
};
</script>